import React, { useCallback } from "react";
import { useProviderComparePageContext } from "../Context";
import { ProviderInfo } from "./ProviderInfo";
import { useHistory } from "react-router-dom";
import { buildUri, ROUTE } from "../misc";
import styles from "./ProviderCompareInfo.module.scss";

export const ProviderCompareInfoWithContext: React.FC<{}> = () => {
    const { provider, toProvider, metadata } = useProviderComparePageContext();
    const history = useHistory();

    const id = provider?.adminId;
    const toId = toProvider?.adminId;

    const onLeftFeatureClick: (args: { code: string; feature: Record<string, unknown> }) => void = useCallback(
        ({ code }) => {
            history.push(
                buildUri(
                    ROUTE.PROVIDER_COMPARE,
                    {},
                    {
                        from: code,
                        to: toId
                    }
                )
            );
        },
        [toId, history]
    );

    const onRightFeatureClick: (args: { code: string; feature: Record<string, unknown> }) => void = useCallback(
        ({ code }) => {
            history.push(
                buildUri(
                    ROUTE.PROVIDER_COMPARE,
                    {},
                    {
                        from: id,
                        to: code
                    }
                )
            );
        },
        [id, history]
    );
    return (
        <>
            <div className="col-12 col-md-6">
                <div className="row">
                    <ProviderInfo
                        enabledHeightWatching={true}
                        allowOnClick={true}
                        provider={provider}
                        metadata={metadata}
                        className={styles.providerInCompare}
                        onFeatureClick={onLeftFeatureClick}
                        onRemove={() => {
                            history.push(
                                buildUri(
                                    ROUTE.PROVIDER_INFO,
                                    {},
                                    {
                                        id: toId
                                    }
                                )
                            );
                        }}
                    />
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="row">
                    <ProviderInfo
                        enabledHeightWatching={true}
                        allowOnClick={true}
                        provider={toProvider}
                        metadata={metadata}
                        className={styles.providerInCompare}
                        onFeatureClick={onRightFeatureClick}
                        onRemove={() => {
                            history.push(
                                buildUri(
                                    ROUTE.PROVIDER_INFO,
                                    {},
                                    {
                                        id
                                    }
                                )
                            );
                        }}
                    />
                </div>
            </div>
        </>
    );
};
